<template>
  <svg viewBox="0 0 849.7 594" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <linearGradient id="linear-gradient" x1="680.2" x2="828.4" y1="416.2" y2="416.2" gradientUnits="userSpaceOnUse">
      <stop stop-color="#a1b003" offset="0"/>
      <stop stop-color="#bac803" offset="1"/>
    </linearGradient>
    <clipPath id="clip-path">
      <circle class="cls-1" cx="677.1" cy="215.5" r="74.1"/>
    </clipPath>
    <linearGradient id="linear-gradient-2" x1="594" x2="757.2" y1="215" y2="215" xlink:href="#linear-gradient"/>
    <linearGradient id="linear-gradient-3" x1="349.6" x2="497.8" y1="100.8" y2="100.8" xlink:href="#linear-gradient"/>
    <linearGradient id="linear-gradient-4" x1="97.34" x2="245.5" y1="215.5" y2="215.5" xlink:href="#linear-gradient"/>
    <clipPath id="clip-path-2">
      <circle class="cls-1" cx="93.13" cy="416.2" r="74.1"/>
    </clipPath>
    <linearGradient id="linear-gradient-5" x1="7.82" x2="178.4" y1="416.2" y2="416.2" xlink:href="#linear-gradient"/>
    <linearGradient id="linearGradient1025" x1="680.2" x2="828.4" y1="416.2" y2="416.2" gradientUnits="userSpaceOnUse" xlink:href="#linear-gradient"/>
    <filter id="grayscale">
      <feColorMatrix type="matrix" values="0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"/>
    </filter>
  </defs>
  <path d="M747 571.9H102.2l151.7-48.61h379.3z" fill="#af7f4a"/>
  <path class="cls-3" d="M189 548v5.72h107.9l19.3-7.86v-5.72z" fill="#76888c"/>
  <path class="cls-4" d="M316.3 540.1h-92.93l-34.31 7.86h107.2z" fill="#9bbabf"/>
  <path class="cls-5" d="M439.9 528.3a2.5 2.5 0 0 1-2.5-2.5v-80.06a2.5 2.5 0 0 1 2.5-2.51h144.7l40.68-14.85a2.502 2.502 0 0 1 1.72 4.7l-41.1 15a2.55 2.55 0 0 1-.86.15h-142.6v77.56a2.5 2.5 0 0 1-2.5 2.51z" fill="#282f30"/>
  <path d="M515.7 476.1h16.57l26.51-14.58s13.91-6 1.32-17.23a92.2 92.2 0 0 0-39.12-14.58s-23.19 2-35.12 13.91c0 0-10.6 8 4.64 17.23z" fill="#6a9da5"/>
  <path d="M496.4 454.7s-7.14 0-10 9.5l17.87 24.41-34.28 14.25v11.53h93.64v-11.53l-16.47-14.25 15.72-26.45-9.29-6.78z" fill="#303c3d"/>
  <path class="cls-8" d="M502.8 451.5s-7.15 0-10 10l17.87 25.74-38.6 15v12.15h97.88v-12.13l-16.44-15 15.72-27.88-9.28-7.16z" fill="#475456"/>
  <path d="M364.2 367.1h26.45v7.86H364.2z" fill="#384142"/>
  <path class="cls-10" d="M356.3 514.4h-8.58L369.88 370h8.58z" fill="#5b6a6d"/>
  <path d="M286.3 402.9s-5.72 22.16-15 10c0 0-27.88-31.45-27.17-68.62 0 0 0-10.72 21.45-9.29-.01.04 27.15-3.57 20.72 67.91z" fill="#3e646d"/>
  <path class="cls-12" d="M267 378.3L490.8 315l-6.58-24.14-223.8 63.31z" fill="#50707c"/>
  <path class="cls-13" d="M262 355.4l223.8-63.3-2.29-4.13-223.8 63.31zm5 22.16l223.8-63.3-2.3-4.13-223.8 63.31z" fill="#759daa"/>
  <path class="cls-14" d="M268.4 381.9l223.8-63.31-2.3-4.12-223.8 63.3z" fill="#2a3c42"/>
  <path class="cls-12" d="M499.3 309.9l-9.27 4.29 1.79 47.54s28.93-16.09 7.48-51.83z" fill="#50707c"/>
  <path class="cls-13" d="M474.2 302.8l14.3 30.74 3.69-14.94-9.41-19.37z" fill="#759daa"/>
  <path class="cls-3" d="M498.6 337.1l31.45 84.34-2.14 7.15 4.28 7.15h7.87l3.57-7.15-2.86-7.86h-4.29l-30.73-85.06z" fill="#76888c"/>
  <path class="cls-10" d="M483.1 353.5l29.77 79.83-2.03 6.76 4.06 6.77h7.44l3.38-6.77-2.71-7.44h-4.05l-29.09-80.5z" fill="#5b6a6d"/>
  <path class="cls-3" d="M347.7 514.4h-8.58L366.29 365h8.57zm71.48 0h8.58L391.31 370h-8.58zm-87.44 3.57h258.8v30.74h-258.8z" fill="#76888c"/>
  <path class="cls-4" d="M327.1 512.2h268v10.01h-268zm0 30.74h268v10.01h-268z" fill="#9bbabf"/>
  <path d="M526.4 470.8h17.87l28.59-15.72s15-6.43 1.43-18.59a99.5 99.5 0 0 0-42.18-15.72s-25 2.14-37.88 15c0 0-11.44 8.58 5 18.58z" fill="#84b6c1"/>
  <path class="cls-8" d="M633.7 560.5a3.22 3.22 0 0 1-3.22-3.21v-27.88h-187.3a3.22 3.22 0 1 1 0-6.43h190.5a3.21 3.21 0 0 1 3.21 3.21v31.1a3.21 3.21 0 0 1-3.21 3.21z" fill="#475456"/>
  <path class="cls-5" d="M259.8 542.3h-4.29l6.43-140.8h4.29z" fill="#282f30"/>
  <path class="cls-3" d="M251.2 509.4h14.3v2.14h-14.3zm-2.86 4.29h18.59v4.29h-18.59zm2.86 15.73h12.87v5H251.2zm.72 10.01h12.87v4.29h-12.87z" fill="#76888c"/>
  <path d="M281.2 401.4s-5.71 22.16-15 10c0 0-27.87-31.46-27.16-68.63 0 0 0-10.72 21.45-9.29-.01.01 27.15-3.52 20.71 67.92z" fill="#5c8c9b"/>
  <path class="cls-13" d="M389.9 367.1h-25.02l2.14-15.01h20.73z" fill="#759daa"/>
  <path class="cls-14" d="M480.8 317.4l6.31 13.22 2.88-16.44a55.32 55.32 0 0 1 4.29 45s-10 14.3-16.44-11.43l6.43-4.29-7.28-20.34z" fill="#2a3c42"/>
  <path class="cls-8" d="M442.8 560.5a3.21 3.21 0 0 1-3.21-3.21v-127.3a3.22 3.22 0 0 1 3.21-3.22h185.1a3.22 3.22 0 0 1 0 6.44H446v124a3.22 3.22 0 0 1-3.2 3.26z" fill="#475456"/>
  <g id="boton5" class="fix-svg-origin hvr hvr-scale" @click="mostrar(5)" :class="{'active':vistos[5-1]}">
    <circle cx="754.3" cy="416.1" r="74.1" :fill="vistos[4]?'url(#linearGradient1025)':'#aaa'"/>
    <g id="casco" class="fix-svg-origin">
      <path d="M702.3 418.2s-12.89 8.59.71 17.9c0 0 12.18 9.31 18.62 9.31A116.2 116.2 0 0 1 745.97 459s17.19 10.74 28.64 6.45c0 0 40.1-11.46 37.23-20.77 0 0-7.87-19.33-27.92-26.49z" fill="#9aacb2"/>
      <path class="cls-19" d="M702.3 416.7s-12.89 8.59.71 17.9c0 0 12.18 9.31 18.62 9.31a116.2 116.2 0 0 1 24.34 13.6s17.19 10.74 28.64 6.45c0 0 40.1-11.46 37.23-20.77 0 0-7.87-19.33-27.92-26.49z" fill="#e4ecef"/>
      <path class="cls-20" d="M710.9 434.6s35.08 18.62 67.3 5c0 0 15.75-5.73 10.74-25.06s-9.31-43.67-47.25-45.1c0 0-40.81 0-40.1 49.4 0 .01 2.15 12.16 9.31 15.76z" fill="#fff"/>
      <path class="cls-21" d="M732.8 444.2s-.72-10.74 4.3-12.89c0 0 26.49-3.57 21.48-20.76 0 0-9.67-37.94-35.62-35.44 0 0 4.11-7.52 18.43-6.08 0 0 26.49 0 37.95 37.23 0 0 5 10.74 10 10a22.82 22.82 0 0 1 2.69 14.95s-15.56 23.02-59.23 12.99z" fill="#86acb2"/>
      <path class="cls-22" d="M733.8 443.2s-.72-10.74 4.3-12.89c0 0 26.49-3.57 21.48-20.76 0 0-9.67-37.94-35.62-35.44 0 0 4.11-7.52 18.43-6.08 0 0 26.49 0 37.95 37.23 0 0 5 10.74 10 10a38.51 38.51 0 0 1 .72 15.75s-13.59 22.22-57.26 12.19z" fill="#d3ecf4"/>
      <path class="cls-21" d="M714 436.2l1-13s-9-6-11-12l-2 1v8s1 12 12 16z" fill="#86acb2"/>
      <path class="cls-22" d="M713 436.2l1-13s-9-6-11-12l-2 1v8s1 12 12 16z" fill="#d3ecf4"/>
      <path class="cls-20" d="M760 390.2s-12-19.5-33-18.75a16 16 0 0 1 6-5.25s10-4 30 14z" fill="#fff"/>
      <path class="cls-19" d="M767 388.2l-7 2s1-7 3-10c0 0 5 3 4 8z" fill="#e4ecef"/>
    </g>
    <circle class="cls-23" cx="754.3" cy="416.1" r="74.1" fill="none" stroke="#beeb7b" stroke-miterlimit="10" stroke-width="3"/>
  </g>
  <g id="boton4" class="fix-svg-origin hvr hvr-scale" @click="mostrar(4)" :class="{'active':vistos[3]}">
    <g clip-path="url(#clip-path)">
      <circle cx="675.6" cy="215" r="81.62" :fill="vistos[3]?'url(#linear-gradient-2)':'#dddd'"/>
      <path id="vision" d="M600.1 175.7l53 31v11l-56 26s-15-42 3-68z" fill="#ff801c"/>
      <path class="cls-27" d="M681.6 297.7c-.14-1-.26-1.86-.4-2.72-.65-4.11-1.58-18.15-4.15-21.55-1.74-2.28-3.48-4.69-6.87-4.52-1.75.1-3.51.19-5.26.3-3.94.24-7.87.6-11.81.7a6.44 6.44 0 0 1-6.1-3.8 10.08 10.08 0 0 1-1.12-6.37 4.38 4.38 0 0 0-1.57-4.17c-2.46-2.27-2.72-4-.92-6.77-.35-.31-.71-.61-1.06-.94-1.71-1.6-2.49-3.29-1.36-5.71s.49-3.32-2-4.27c-4.39-1.69-5.09-4.38-2.38-8.25s5.19-7.77 7.66-11.72a7.51 7.51 0 0 0 .74-5.53c-.35-1.86-.73-3.71-1-5.59-.53-3.53.12-7 .88-10.42 1.1-5 2.2-10 4.91-14.41 4.45-7.26 11-12.07 18.79-15.11a83.3 83.3 0 0 1 34.19-5.57 35.22 35.22 0 0 1 13.87 3.1c10 4.79 16.19 13.05 20.49 22.9 2.91 6.67 3.17 13.81 2.92 20.95a36.64 36.64 0 0 1-7 20.28 65.75 65.75 0 0 0-4.8 8.52 33.1 33.1 0 0 0-3.2 19.44 72.09 72.09 0 0 0 7.32 22.5c1.4 2.81 2.63 15.7 4 18.73z" fill="#043"/>
      <circle class="cls-20" cx="690.3" cy="211" r="25" fill="#fff"/>
      <g id="flecha" fill="none" stroke="#00dbd7">
        <circle class="cls-28" cx="690.3" cy="211" r="16.5" stroke-miterlimit="10" stroke-width="5"/>
        <path class="cls-28" d="M615.6 211h58.5" stroke-miterlimit="10" stroke-width="5"/>
        <path d="M625.6 201.7l-10 9 10 9.5" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"/>
      </g>
    </g>
    <circle class="cls-23" cx="677.1" cy="215.5" r="74.1" fill="none" stroke="#beeb7b" stroke-miterlimit="10" stroke-width="3"/>
  </g>
  <g id="boton3" class="fix-svg-origin hvr hvr-scale" @click="mostrar(3)" :class="{'active':vistos[3-1]}">
    <circle cx="423.7" cy="100.8" r="74.1" :fill="vistos[2]?'url(#linear-gradient-2)':'#eee'"/>
    <path d="M366.8 59.43V87.8c0 3.65 16.11 6.6 36 6.6s36-3 36-6.6V59.43z" fill="#0b4e60"/>
    <ellipse class="cls-32" cx="402.8" cy="59.43" rx="35.97" ry="6.6" fill="#107ba0"/>
    <path class="cls-20" d="M397.2 88.73h11.34v1.89H397.2zm0-6.29h11.34v1.89H397.2zm0-6.3h11.34v1.89H397.2zm0-6.3h11.34v1.89H397.2z" fill="#fff"/>
    <path class="cls-34" d="M396.2 65.11h1.89V94.4h-1.89zm11.33 0h1.89V94.4h-1.89z" fill="#ffd8b8"/>
    <path d="M404.2 79.85V110c0 3.87 17.11 7 38.23 7s38.22-3.15 38.22-7V79.85z" fill="#0b5670"/>
    <ellipse class="cls-32" cx="442.4" cy="79.85" rx="38.23" ry="7.01" fill="#107ba0"/>
    <path class="cls-20" d="M436.4 111h12.05v2.01H436.4zm0-6.7h12.05v2.01H436.4zm0-6.69h12.05v2.01H436.4zm0-6.7h12.05v2.01H436.4z" fill="#fff"/>
    <path class="cls-34" d="M435.4 85.89h2.01v31.13h-2.01zm12.05 0h2.01v31.13h-2.01z" fill="#ffd8b8"/>
    <path class="cls-36" d="M377.6 106.8v34c0 4.36 19.28 7.9 43.06 7.9s43.05-3.54 43.05-7.9v-34z" fill="#0e5d80"/>
    <ellipse class="cls-32" cx="420.6" cy="106.8" rx="43.05" ry="7.9" fill="#107ba0"/>
    <g id="agua" fill="#493e36">
      <ellipse cx="402.8" cy="58.86" rx="34.02" ry="5.31"/>
      <ellipse cx="442.4" cy="79.24" rx="36.15" ry="5.65"/>
      <ellipse cx="420.6" cy="106.1" rx="40.72" ry="6.36"/>
    </g>
    <path class="cls-20" d="M413.8 141.9h13.57v2.26H413.8zm0-7.54h13.57v2.26H413.8zm0-7.54h13.57v2.26H413.8zm0-7.54h13.57v2.26H413.8z" fill="#fff"/>
    <path class="cls-34" d="M412.7 113.6h2.26v35.06h-2.26zm13.57 0h2.26v35.06h-2.26z" fill="#ffd8b8"/>
    <circle class="cls-23" cx="423.7" cy="100.8" r="74.1" fill="none" stroke="#beeb7b" stroke-miterlimit="10" stroke-width="3"/>
  </g>
  <g id="boton2" class="fix-svg-origin hvr hvr-scale hvr-rotate-360" @click="mostrar(2)" :class="{'active':vistos[2-1]}">
    <circle cx="171.4" cy="215.5" r="74.1" :fill="vistos[1]?'url(#linear-gradient-4)':'#eee'" />
    <path class="cls-27" d="M121.5 229.5h67.83v6.6H121.5zm74.06-29.06h12.88v27.45h-12.88z" fill="#043"/>
    <path class="cls-36" d="M234.2 205.9v31.88a3.84 3.84 0 0 1-3.83 3.83h-115.3a3.5 3.5 0 0 1 0-7h88.1v-39h20.77a10.28 10.28 0 0 1 10.27 10.23z" fill="#0e5d80"/>
    <path d="M201.5 206.5v15.3a10.11 10.11 0 0 1-10.11 10.1h-72.54a10.11 10.11 0 0 1-10.11-10.1v-15.3a10.11 10.11 0 0 1 10.11-10.1h72.54a10.11 10.11 0 0 1 10.11 10.1z" fill="#ad0602"/>
    <path d="M201.5 206.5v2.22h-92.76v-2.22a10.11 10.11 0 0 1 10.11-10.1h72.54a10.11 10.11 0 0 1 10.11 10.1zm0 13.08v2.22a10.11 10.11 0 0 1-10.11 10.1h-72.54a10.11 10.11 0 0 1-10.11-10.1v-2.22z" fill="#e81303"/>
    <path class="cls-40" d="M168.1 192h12.28v4.42H168.1z" fill="#64798a"/>
    <path class="cls-40" d="M176.9 182.1a1.55 1.55 0 0 1 0 2.2l-9 9.05a1.57 1.57 0 1 1-2.22-2.21l9.05-9a1.57 1.57 0 0 1 2.17-.04z" fill="#64798a"/>
    <g id="rueda2" class="rueda fix-svg-origin">
      <path class="cls-41" d="M169.3 239.8a9.55 9.55 0 1 1-9.56-9.55 9.56 9.56 0 0 1 9.56 9.55z" fill="#303030"/>
      <path class="cls-40" d="M166.1 239.8a6.36 6.36 0 1 1-6.36-6.36 6.37 6.37 0 0 1 6.36 6.36z" fill="#64798a"/>
      <path class="cls-42" d="M161.4 239.4l4.37 2.58a5.25 5.25 0 0 1-.51 1.07l-4-2.37 1.27 4.9a6.15 6.15 0 0 1-1.11.41l-1.18-4.54-2.57 4.36a6 6 0 0 1-1.09-.5l2.38-4-4.9 1.26a5.53 5.53 0 0 1-.4-1.12l4.54-1.18-4.37-2.57a5.33 5.33 0 0 1 .51-1.08l4 2.38-1.27-4.9a6.54 6.54 0 0 1 1.12-.41l1.18 4.54 2.57-4.37a7.1 7.1 0 0 1 1.08.51l-2.39 4 4.91-1.27a4.84 4.84 0 0 1 .41 1.12z" fill="#ebf0f3"/>
    </g>
    <g id="rueda3" class="rueda fix-svg-origin">
      <path class="cls-41" d="M228.8 239.8a9.55 9.55 0 1 1-9.55-9.55 9.56 9.56 0 0 1 9.55 9.55z" fill="#303030"/>
      <path class="cls-40" d="M225.6 239.8a6.37 6.37 0 1 1-6.37-6.36 6.37 6.37 0 0 1 6.37 6.36z" fill="#64798a"/>
      <path class="cls-42" d="M220.9 239.4l4.37 2.58a5.8 5.8 0 0 1-.5 1.07l-4.05-2.37 1.27 4.9a5.88 5.88 0 0 1-1.11.41l-1.18-4.54-2.57 4.36a6 6 0 0 1-1.09-.5l2.38-4-4.9 1.26a6.22 6.22 0 0 1-.4-1.12l4.54-1.18-4.36-2.57a5.89 5.89 0 0 1 .5-1.08l4 2.38-1.27-4.9a6.35 6.35 0 0 1 1.13-.41l1.17 4.54 2.57-4.37a7.1 7.1 0 0 1 1.08.51l-2.38 4 4.9-1.27a4.84 4.84 0 0 1 .41 1.12z" fill="#ebf0f3"/>
    </g>
    <g id="rueda1" class="rueda fix-svg-origin">
      <path class="cls-41" d="M147 239.8a9.55 9.55 0 1 1-9.56-9.55 9.56 9.56 0 0 1 9.56 9.55z" fill="#303030"/>
      <path class="cls-40" d="M143.8 239.8a6.37 6.37 0 1 1-6.37-6.36 6.37 6.37 0 0 1 6.37 6.36z" fill="#64798a"/>
      <path class="cls-42" d="M139.1 239.4l4.37 2.58a6.57 6.57 0 0 1-.51 1.07l-4-2.37 1.27 4.9a6.25 6.25 0 0 1-1.19.42l-1.18-4.54-2.57 4.36a5.89 5.89 0 0 1-1.08-.5l2.38-4-4.9 1.26a5.53 5.53 0 0 1-.4-1.12l4.54-1.18-4.37-2.57a5.89 5.89 0 0 1 .5-1.08l4 2.38-1.27-4.9a6 6 0 0 1 1.12-.41l1.23 4.5 2.57-4.37a7.21 7.21 0 0 1 1.09.51l-2.39 4 4.91-1.27a5.35 5.35 0 0 1 .41 1.12z" fill="#ebf0f3"/>
    </g>
    <path d="M224.8 215.4a.71.71 0 0 1 .71.71v2.87a6.6 6.6 0 0 0-7 0v-2.88a.71.71 0 0 1 .71-.71z" fill="#2f4859"/>
    <path d="M234.2 205.9v6.43h-19.15v-12.36h17.18a10.2 10.2 0 0 1 1.97 5.93z" fill="#00dbd7"/>
    <path class="cls-27" d="M204.9 183.6v10.67h21.46a8.32 8.32 0 0 0-4.5-7.55c-3.29-1.91-8.67-3.12-16.96-3.12z" fill="#043"/>
    <circle class="cls-20" cx="154.9" cy="213.6" r="13.81" fill="#fff"/>
    <path d="M161 215.8a6.16 6.16 0 1 1-12.32 0c0-3.4 5.91-11.09 6.16-11.09S161 212.4 161 215.8z"/>
    <circle class="cls-23" cx="171.4" cy="215.5" r="74.1" fill="none" stroke="#beeb7b" stroke-miterlimit="10" stroke-width="3"/>
  </g>
  <g id="boton1" clip-path="url(#clip-path-2)" class="fix-svg-origin hvr hvr-scale hvr-rotate-360" @click="mostrar(1)" :class="{'active':vistos[1-1]}">
    <circle cx="93.13" cy="416.1" r="85.31" :fill="vistos[0]?'url(#linear-gradient-5)':'#eee'"/>
    <path class="cls-47" d="M8.84 396.8h168.6v38.69H8.84z" fill="#678687"/>
    <path d="M64.11 386h58.04v60.19H64.11z" fill="#98cfd8"/>
    <g id="valvula" class="fix-svg-origin">
      <g fill="#e54013">
        <path class="cls-49" d="M93.13 468.6a52.49 52.49 0 1 1 52.49-52.48 52.54 52.54 0 0 1-52.49 52.48zm0-96.37A43.89 43.89 0 1 0 137 416.12a43.94 43.94 0 0 0-43.87-43.89z"/>
        <path class="cls-49" d="M88.89 367.7h8.6v47.29h-8.6z"/>
        <path class="cls-49" transform="rotate(-33.02 71.71 429)" d="M46.06 424.7h51.28v8.6H46.06z"/>
        <path class="cls-49" transform="rotate(-56.98 114.7 429)" d="M110.4 403.4h8.6v51.28h-8.6z"/>
      </g>
      <circle class="cls-47" cx="93.13" cy="416.1" r="10.75" fill="#678687"/>
    </g>
    <circle class="cls-23" cx="93.13" cy="416.1" r="74.1" fill="none" stroke="#beeb7b" stroke-miterlimit="10" stroke-width="3"/>
  </g>
</svg>

</template>
<script>
export default {
  data(){
    return {
      vistos: Array(5).fill(false)
    }
  },
  methods: {
    mostrar(idx) {
      this.$set(this.vistos,idx-1,true)
      this.$emit('mostrar',idx - 1)
      var todosVistos = this.vistos.every(el => {return el})
      if(todosVistos) {
        this.$emit('finished')
      }
    }
  }
}
</script>


<style lang="scss" scoped>
svg {
  max-height: 50vh;
}
#valvula, .rueda {
  transition: all 1s;
}
.hvr-rotate-360:hover {
  #valvula, .rueda {
    transform: rotate(360deg)
  }
}

.hvr-scale {
  filter: url(#grayscale);
  #agua, #flecha, #vision, #casco {
    transition: all 500ms;
  }
  #flecha {
    transform: translateX(20px);
    transform-box: fill-box;
    transform-origin: center;
  }
  #vision, #flecha {
    opacity: 0;
  }
  #casco {
    transform: rotate(0);
  }
}
.hvr-scale:hover{
  filter: none;
  #flecha {
    transform: translateX(0);
  }
  #vision, #flecha {
    opacity: 1;
  }
  #casco {
    transform: rotate(-10deg);
  }
}
.active {
  filter: none;
}
.active #flecha, .active #vision {
  transform: translateX(0);
  opacity: 1;

}
  .cls-1,.cls-23,.cls-28{fill:none}.cls-3{fill:#76888c}.cls-4{fill:#9bbabf}.cls-5{fill:#282f30}.cls-8{fill:#475456}.cls-10{fill:#5b6a6d}.cls-12{fill:#50707c}.cls-13{fill:#759daa}.cls-14{fill:#2a3c42}.cls-19{fill:#e4ecef}.cls-20{fill:#fff}.cls-21{fill:#86acb2}.cls-22{fill:#d3ecf4}.cls-23{stroke:#beeb7b;stroke-width:3px}.cls-23,.cls-28{stroke-miterlimit:10}.cls-27{fill:#043}.cls-28{stroke:#00dbd7;stroke-width:5px}.cls-32{fill:#107ba0}.cls-33{fill:#493e36}.cls-34{fill:#ffd8b8}.cls-36{fill:#0e5d80}.cls-40{fill:#64798a}.cls-41{fill:#303030}.cls-42{fill:#ebf0f3}.cls-47{fill:#678687}.cls-49{fill:#e54013}
</style>